import { connect } from "react-redux";
import { Form } from "formik";
import moment from "moment-timezone";
import React, { Component } from "react";

import {
  BS_INITIAL_VALUES,
  BS_SCHEMA,
  P_INITIAL_VALUES,
  P_SCHEMA,
} from "@/containers/Dashboard/Providers/PatientProfileView/schema/newNoteFormSchema";
import {
  BS_VALIDATION_SCHEMA,
  P_VALIDATION_SCHEMA,
} from "@/containers/Dashboard/Providers/PatientProfileView/schema/newNoteValidation";
import Button from "@/components/UI/Button";
import {
  createCommonNoteData,
  getNoteCard,
  getNoteFields,
  pickNoteDate,
  setBehavioralNoteData,
  setPrescriberNoteData,
  getICD10Dataset,
} from "@/features/notes/(legacy)/components/ProgressNotes";
import { getCompletedCalls } from "@/features/notes/helpers/completed-calls";
import { getQueryParams } from "@/utils/filters";
import { isAuthorized } from "@/utils/authToken";
import { providerRequests } from "@/api/(requests)/provider";
import { showLoader } from "@/redux/actions/loader";
import store from "@/redux/store";
import { timeSlotArray } from "@/components/Provider/ScheduleAvailability/constants";
import { transformTimeSlotArray } from "@/components/Provider/ScheduleAvailability/ScheduleEvent";

class NewNote extends Component {
  constructor(props) {
    super(props);
    let session = parseInt(getQueryParams("numSessions", this.props.location.search.trim())) + 1;
    let title = "Individual therapy # " + session;

    this.state = {
      behavioral: isAuthorized("provider:behavioral"),
      completedCalls: [],
      ICD10: [],
      isSigned: false,
      patientId: this.props.match.params.patientId,
      prescribe: isAuthorized("provider:prescribe"),
      sessionFrom: "",
      sessionTo: "",
      timeSlotOptions: transformTimeSlotArray([...timeSlotArray]),
      title: title,
    };
  }

  componentDidMount = async () => {
    try {
      getICD10Dataset(this);
      let urlParams = { patientId: this.state.patientId };
      const completedCalls = await getCompletedCalls(urlParams);

      this.setState({ completedCalls: completedCalls });
    } catch (e) {
      console.log(e);
    }
    document.addEventListener("change", this.formChangeHandler, {
      capture: true,
    });
  };

  formChangeHandler = (e) => {
    if (e.target.name === "session_from") {
      this.setState({ sessionFrom: moment(e.target.value, "hh:mm a").format("HH:mm") });
    } else if (e.target.name === "session_to") {
      this.setState({ sessionTo: moment(e.target.value, "hh:mm a").format("HH:mm") });
    }
  };

  submitHandler = async (formData, actions, draft) => {
    store.dispatch(showLoader());
    let data = await createCommonNoteData(this, formData, this.state.title, this.props.profile);

    if (this.state.behavioral) {
      setBehavioralNoteData(this, formData, this.state.title, data);
    } else {
      setPrescriberNoteData(this, formData, this.state.title, data);
    }

    if (draft) {
      data.note_state = "draft";
    }

    let urlParams = { patientId: this.state.patientId };

    providerRequests
      .post_progress_note({ data, urlParams })
      .then(() => {
        this.props.history.go(-1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  cancelClickHandler = () => {
    this.submitHandler(this.noteData, {}, true);

    if (this.state.behavioral) {
      if (
        this.noteData.patient_report === "" &&
        this.noteData.patient_task === "" &&
        this.noteData.intervention_reaction === "" &&
        this.noteData.interventions === ""
      ) {
        this.props.history.go(-1);

        return;
      }
    } else {
      if (
        this.noteData.patient_reported === "" &&
        this.noteData.prescriber_interventions === "" &&
        this.noteData.intervention_reaction === ""
      ) {
        this.props.history.go(-1);

        return;
      }
    }
  };

  getPickedDate = (dateString) => {
    pickNoteDate(this, dateString);
  };

  signatureClickHandler = async (e, formikProps) => {
    const isSigned = !this.state.isSigned;

    await formikProps.setFieldValue("isSigned", isSigned);
    formikProps.setFieldTouched("isSigned");
    this.setState({ isSigned: isSigned });
  };

  renderForm = (formikProps) => {
    this.noteData = formikProps.values;
    let schema;

    if (this.state.behavioral) {
      schema = BS_SCHEMA;
    } else {
      schema = P_SCHEMA;
    }
    const callIdIndex = schema.findIndex((el) => el["name"] === "call_id");

    if (callIdIndex) {
      schema[callIdIndex].elementConfig.options = this.state.completedCalls;
    }

    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container">{getNoteFields(formikProps, schema, this)}</div>
        </div>

        <div className="d-flex justify-content-lg-end tw:justify-center">
          <Button
            className="Btn Btn--otl-pri Btn-sm mr-3"
            onClick={() => {
              this.cancelClickHandler();
            }}
            type="button"
          >
            Save Draft
          </Button>

          <Button className="Btn Btn--pri Btn-sm" type="submit">
            Add Note
          </Button>
        </div>
      </Form>
    );
  };

  renderTitle = () => {
    return (
      <div className="ml-0 ml-lg-3">
        <b>{this.state.title}</b>
      </div>
    );
  };

  render() {
    let vals;
    let validation;

    if (this.state.behavioral) {
      vals = BS_INITIAL_VALUES;
      validation = BS_VALIDATION_SCHEMA;
    } else {
      vals = P_INITIAL_VALUES;
      validation = P_VALIDATION_SCHEMA;
    }
    vals["title"] = this.state.title;

    return <div>{getNoteCard(vals, validation, this)}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps)(NewNote);
